import { css, styled } from "styled-components";

import {
  poppins_body_md_medium,
  poppins_body_md_semibold,
  poppins_body_sm_regular,
} from "../font/poppins/body";
import {
  poppins_heading_lg,
  poppins_heading_md,
  poppins_heading_sm,
} from "../font/poppins/heading";

export const markdownStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  color: #2a2f37;

  h1 {
    ${poppins_heading_lg}
    margin-top: 1.6rem;

    &:first-child {
      margin-top: 0;
    }
  }

  h2 {
    ${poppins_heading_md}
    margin-top: 1.4rem;

    &:first-child {
      margin-top: 0;
    }
  }

  h3,
  h4,
  h5,
  h6 {
    ${poppins_heading_sm}
    margin-top: 1.2rem;

    &:first-child {
      margin-top: 0;
    }
  }

  p {
    ${poppins_body_md_medium}
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ul > li {
    position: relative;
    ${poppins_body_md_medium};
    padding: 0.2rem 0.4rem 0.2rem 1.5rem;

    &::before {
      content: "";
      position: absolute;
      left: 0.4rem;
      top: 1.2rem;
      transform: translateY(-50%);
      width: 0.3rem;
      height: 0.3rem;
      background-color: #2a2f37;
      border-radius: 50%;
    }
  }

  ol {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding-left: 1.6rem;
    margin: 0;
  }

  ol > li {
    ${poppins_body_md_medium}
    list-style-type: decimal;
    padding: 0.2rem 0.4rem;
  }

  pre {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    background: #f5f7fa;
    border-radius: 0.4rem;
    padding: 1.2rem 1.6rem;
    overflow-x: auto;
  }

  code {
    ${poppins_body_sm_regular}
    background: #f5f7fa;
    border-radius: 0.2rem;
    padding: 0.1rem 0.4rem;
  }

  pre code {
    background: none;
    padding: 0;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  del {
    text-decoration: line-through;
    color: #515c6c;
  }

  a {
    color: #1a73e8;
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }

  blockquote {
    border-left: 3px solid #b1b8c4;
    padding: 0.4rem 1.2rem;
    margin: 0;
    color: #515c6c;
    ${poppins_body_md_medium}
  }

  table {
    width: 100%;
    border-collapse: collapse;
    ${poppins_body_md_medium}
  }

  th {
    ${poppins_body_md_semibold}
    background: #f5f7fa;
    border: 1px solid #e5e7eb;
    padding: 0.8rem 1.2rem;
    text-align: left;
  }

  td {
    border: 1px solid #e5e7eb;
    padding: 0.8rem 1.2rem;
  }

  hr {
    border: none;
    border-top: 1px solid #e5e7eb;
    margin: 1.2rem 0;
    width: 100%;
  }
`;

export const Wrapper = styled.div`
  ${markdownStyle}
`;
